import {
  put,
  all,
} from 'redux-saga/effects';
import * as baseTypes from './base/types';
import * as configDataTypes from './configData/types';
import * as configContainerTypes from './configContainer/types';
import * as logDataTypes from './logData/types';

import { sagas as baseSagas } from './base';
import { sagas as configDataSagas } from './configData';
import { sagas as configContainerSagas } from './configContainer';
import { sagas as logDataSagas } from './logData';

function* init() {
  yield all([
    put({ type: baseTypes.INIT }),
    put({ type: configDataTypes.INIT }),
    put({ type: configContainerTypes.INIT }),
    put({ type: logDataTypes.INIT }),
  ]);
}

export default [
  init,
  ...baseSagas,
  ...configDataSagas,
  ...configContainerSagas,
  ...logDataSagas,
];
